import React from 'react'
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa'

export default function SignInFooter() {
  const handleIconClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="mt-6 text-center">
      <p className="text-gray-400 mb-4">
        Hydra Score™ is a precision water and land data analytics platform.
      </p>
      <div className="flex justify-center space-x-4">
        <SocialIcon
          Icon={FaFacebookF}
          url="https://www.facebook.com/profile.php?id=61560861611781"
          onClick={handleIconClick}
        />
        <SocialIcon
          Icon={FaYoutube}
          url="https://www.youtube.com/channel/UCOfzLw8uh-KvxDKqDjsmBzA"
          onClick={handleIconClick}
        />
        <SocialIcon
          Icon={FaLinkedinIn}
          url="https://www.linkedin.com/company/hydra-score/about/?viewAsMember=true"
          onClick={handleIconClick}
        />
      </div>
    </div>
  )
}

function SocialIcon({
  Icon,
  url,
  onClick,
}: {
  Icon: React.ElementType
  url: string
  onClick: (url: string) => void
}) {
  return (
    <Icon
      style={{
        width: '20px',
        height: '20px',
        color: 'gray',
        cursor: 'pointer',
        borderRadius: '4px',
      }}
      onClick={() => onClick(url)}
    />
  )
}
